import React from "react";

const SelectedPayment = ({ selectedPayment }) => {
  const paymentData = [
    { label: "Payment name", value: selectedPayment?.title },
    { label: "Fee", value: "Free" },
    { label: "Process Time", value: "12 Hours" },
    { label: "Min", value: `${selectedPayment?.min} dt` },
    { label: "Max", value: `${selectedPayment?.max} dt` },
  ];
  const mobilePaymentData = {
    image: selectedPayment?.image,
    name: selectedPayment?.title,
    fee: "Free",
    processTime: "12 Hours",
    min: selectedPayment?.min,
    max: selectedPayment?.max,
  };

  console.log(selectedPayment, "selectedPayment");
  return (
    <>
      <div className="md:flex hidden justify-between max-w-[560px] bg-white/5 rounded py-[10px] px-[20px]">
        {selectedPayment &&
          paymentData.map((e) => {
            return (
              <span className="flex flex-col justify-between">
                <h1 className="text-white/60 text-[12px] leading-none">{e.label}</h1>
                <p className="text-white/90 mt-[4px] text-[12px]">{e.value}</p>
              </span>
            );
          })}
      </div>
      {/* mobilePaymentData */}
      <div className="block md:hidden">
        {selectedPayment && (
          <div className="flex items-center w-full bg-white/10 rounded-md overflow-hidden flex-1">
            <div className="border-r bg-white px-3 h-[80px] flex items-center justify-center border-black max-w-36">
              <img src={mobilePaymentData.image} alt={mobilePaymentData.name} />
            </div>
            <div className="w-full text-[12px] py-2 px-4">
              <ul className="flex justify-between mb-5">
                <li className="text-white/70">Fee: {mobilePaymentData.fee}</li>
                <li className="text-white/40">Instant</li>
              </ul>
              <ul className="flex w-full justify-between">
                <li className="leading-none">
                  <small className="text-white/40">Min</small>
                  <p className="text-white/70 font-medium">{mobilePaymentData.min} dt</p>
                </li>
                <li className="leading-none text-right">
                  <small className="text-white/40">Max</small>
                  <p className="text-white/70 font-medium">{mobilePaymentData.max} dt</p>
                </li>
              </ul>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default SelectedPayment;
